const personalisationScriptLoad = function() {
  /**
   * Removes HTML tags from a string.
   * @param {string} str - The input string.
   * @return {string} - The string with HTML tags removed.
   */
  function removeTags(str) {
    if ((str === null) || (str === '')) {
      return false;
    } else {
      str = str.toString();
    }

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/ig, '');
  }

  const findCourse = document.getElementById('course-title');
  // Will need this putting on the h1 of every course page
  const findRecent = document.getElementById('recent-activity');
  // This needs to go on the recent activity on the home page

  if (findCourse != null) {
    // This will take down the coursetitle and url if the conditions are met.
    localStorage.setItem('courseTitle', findCourse.innerHTML);
    localStorage.setItem('courseURL', window.location.href);
  }

  if (findRecent != null && localStorage.getItem('courseTitle') != null && localStorage.getItem('courseURL') != null) {
    findRecent.classList.remove('d-none');

    const persoText = `
    <a href="` + localStorage.getItem('courseURL') + `">
    <div class="card bg-white h-100 border-0">
    <div class="card-header d-flex align-items-center bg-white text-dark">
    <p class="mb-0">` + removeTags(localStorage.getItem('courseTitle')) + `</p>
    <i class="icon icon-right-open flex-end" aria-hidden="true"></i>
    </div>
    </div>
    </a>
    `;

    findRecent.insertAdjacentHTML('afterend', persoText);
  };
};

export default personalisationScriptLoad;
